import './Button.scss'

import React, { forwardRef } from 'react'

import Icon from '../../components/Icon/Icon'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const SIZES = {
  'small': 14,
  'field-sized': 16,
  'default': 20,
  'medium': 20,
  'large': 24
}

const Button = forwardRef(
  (
    { label, size, type, disabled, color, grow, icon, iconPosition, children, ...props },
    ref
  ) => {
  return (
    <button
      ref={ref}
      className={classNames(
        'button',
        '-size-' + size,
        '-type-' + type,
        {
          ['-' + type + '-' + color]: !disabled,
          ['-disabled-' + type + '-' + color]: disabled,
          '-trailing': label && iconPosition === 'trailing',
          '-leading': label && iconPosition === 'leading',
          '-only-icon': !label && !children,
          '-grow': grow,
          'label-small-medium': size === 'small',
          'label-field-sized-medium': size === 'field-sized',
          'label-default-medium': size === 'default',
          'label-medium-medium': size === 'medium',
          'label-large-medium': size === 'large'
        })}
        disabled={disabled}
        {...props}
      >
        {icon && icon !== 'none' && (
          <div className='-icon'>
            <Icon size={SIZES[size]} icon={icon} />
          </div>
        )}
        {label || children}
      </button>
    )
  }
)

Button.propTypes = {
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'field-sized', 'default', 'medium', 'large']),
  type: PropTypes.oneOf(['dark', 'light', 'borderless']),
  disabled: PropTypes.bool,
  grow: PropTypes.bool,
  color: PropTypes.oneOf(['neutral', 'green', 'blue', 'red', 'yellow']),
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(['leading', 'trailing']),
  onClick: PropTypes.func
}

Button.defaultProps = {
  size: 'default',
  color: 'neutral',
  type: 'light',
  iconPosition: 'leading'
}

export default Button
